import { render } from "./ClosetBodyView.vue?vue&type=template&id=c3b97d9c&ts=true"
import script from "./ClosetBodyView.vue?vue&type=script&lang=ts"
export * from "./ClosetBodyView.vue?vue&type=script&lang=ts"

import "./ClosetBodyView.vue?vue&type=style&index=0&id=c3b97d9c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__